/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { getFormValues, isInvalid } from 'redux-form';
import { initialState as initialStateMain } from '../../reducer';
import { initialState } from './reducer';
import { FORM_NAME } from './constants';
import { MY_CARRIER_ID, TENDER_ID } from '../../../request-modal/constants';

export const selectGroupsContainerDomain = state => state.orderGroupsContainerReducer || initialStateMain;
export const selectGroupsCreateReqContainerDomain = state => state.orderGroupsCreateReqContainerReducer || initialState;

export const getModesOptionsSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ modes }) => {
		return modes ? modes.map(value => ({ key: value?.id, text: value?.name_with_symbol, value: value?.id })) : [];
	});

export const getFormIsInvalidCreateSelector = () =>
	createSelector(isInvalid('create-req-modal'), isInvalid => isInvalid);

export const getIsCategoriesLoadingSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ isCategoriesLoading }) => isCategoriesLoading);

export const getCategoriesSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ categories }) => {
		return categories || [];
	});

export const getIsTenderTypesLoadingSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ isTenderTypesLoading }) => isTenderTypesLoading);

export const getTenderTypesSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ tenderTypes }) => {
		return tenderTypes || [];
	});

export const getIsTenderCompaniesLoadingSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ isTenderCompaniesLoading }) => isTenderCompaniesLoading);

export const getTenderCompaniesSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ tenderCompanies }) => {
		return tenderCompanies || [];
	});

export const getIsTypesLoadingSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ isTypesLoading }) => isTypesLoading);

export const getTypesSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, ({ types }) => {
		return types || [];
	});

export const getDataForCreateOrUpdateSelector = () =>
	createSelector(getFormValues(FORM_NAME), formValues => {
		return {
			category_id: formValues.category_id,
			tender_type_id: formValues.tender_type_id,
			tender_tk_id: formValues.tender_tk_id,
			tender_amount: formValues.tender_amount,
			fetch_at: formValues.fetch_at,
			fetch_time_from: formValues.fetch_time_from,
			fetch_time_to: formValues.fetch_time_to,
			type_id: formValues.type_id,
			mode_id: formValues.mode_id,
			cost: formValues.cost,
		};
	});

export const getIsMyCarrierSelectedSelector = () =>
	createSelector(getFormValues(FORM_NAME), formValues => {
		return formValues?.tender_type_id === MY_CARRIER_ID;
	});

export const getFormInitialValuesSelector = () =>
	createSelector(selectGroupsCreateReqContainerDomain, () => {
		return {
			tender_type_id: TENDER_ID,
		};
	});
